import React, { FC } from "react";
import { QuantityIndicator } from "../QuantityIndicator";
import { ProductImage } from "../../../ProductImage";
import {
  StyledInnerWrapper,
  StyledOuterWrapper,
  StyledQuantityWrapper,
} from "./index.styled";

interface ImageAndQuantityProps {
  itemImgSrc: string;
  productTitle: string;
  quantity: number;
}

export const ImageAndQuantity: FC<ImageAndQuantityProps> = ({
  productTitle,
  itemImgSrc = "",
  quantity,
}) => {
  return (
    <StyledOuterWrapper>
      <StyledInnerWrapper>
        <ProductImage
          alt={`packaging for ${productTitle}`}
          src={itemImgSrc}
          size={60}
        />
        {quantity > 1 && (
          <StyledQuantityWrapper>
            <QuantityIndicator quantity={quantity} />
          </StyledQuantityWrapper>
        )}
      </StyledInnerWrapper>
    </StyledOuterWrapper>
  );
};
